enum Edge {
  top,
  bottom,
  left,
  right,
}
export default Edge;
